import { Table } from 'foundations-components/transitional/components/Table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetsTable(props) {
  const {
    assets
  } = props;
  return /*#__PURE__*/_jsxs(Table, {
    bordered: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-multi-account-asset-copier.assetTable.name"
          })
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: assets.map(asset => /*#__PURE__*/_jsx("tr", {
        "data-test-id": "assets-table-row",
        children: /*#__PURE__*/_jsx("td", {
          children: asset.assetName
        })
      }, asset.assetId))
    })]
  });
}
export default AssetsTable;